<div class="m-avt__wrapper">
  <!-- Image or initials -->
  <div class="m-avt" [class]="`m-avt--${size()}`" [class.m-avt--icon]="icon() && !image()">
    @if (image()) {
      <div class="m-avt__image" [style.backgroundImage]="'url(' + image() + ')'"></div>
    }

    @if (icon() && !image()) {
      <div class="m-avt__icon aw-2-txt--center">
        <i class="aw-2-icn" [awIcon]="icon()"></i>
      </div>
    }

    @if (showInitials() && !image() && !icon()) {
      <div class="m-avt__initials" [class]="'m-avt__initials--' + color()">
        {{ letters() }}
      </div>
    }
  </div>
  <ng-content />

  <!-- Label -->
  @if (showLabel()) {
    <div class="m-avt__label aw-2-pl--s">
      <div class="aw-2-txt--truncate">{{ text() }}</div>
      @if (subLabel()) {
        <div class="aw-2-txt--truncate m-type--s m-type--steel">{{ subLabel() }}</div>
      }
    </div>
  }
</div>
